export default "__VITE_ASSET__55CpzKOb__"